import React, { Component } from 'react';//
import { NavLink } from 'react-router-dom';

class MenuItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subMenuIsOpen: this.props.subMenuIsOpen,
            hasSubMenu: this.props.hasSubMenu
        }
        this.toggleSubMenu = this.toggleSubMenu.bind(this);
    }

    toggleSubMenu(event) {
        event.preventDefault();
        if (this.state.hasSubMenu) {
            this.setState({ subMenuIsOpen: !this.state.subMenuIsOpen });
        }
    }

    render() {
        const url = this.props.url ? this.props.url : '#';
        //console.log(this.props);
        const link = this.state.hasSubMenu ?
            <NavLink key={this.props.text} to={url} onClick={this.toggleSubMenu}><span className={"glyphicon glyphicon-" +  this.props.glyphIcon  + " mr-sm"}></span><strong>{this.props.text}</strong></NavLink> :
            <NavLink key={this.props.text} activeClassName="active" to={url}>{this.props.text}</NavLink>;

        const subMenu = this.state.hasSubMenu ?
            <ul className={`dropdown-menu ${this.state.subMenuIsOpen ? 'open' : 'closed'} nav sidebar-nav text-capitalize`}>
                {this.props.children.map(item => <li key={item.props.text}><a href={item.props.url} target={item.props.target}>{item.props.text}</a></li>)}
            </ul> : null;
        return (
            <li key={this.props.text}>
                {link}
                {subMenu}
            </li>
        )
    }
}

export default MenuItem